import globModules from './glob-modules';
import { render } from '@verndale/core';
import InputField from './components/input-field';
import Chatbot from './modules/chatbot.js';

function reactComponent(Component, nodeList) {
  const React = require('react'); //eslint-disable-line
  const { createRoot } = require('react-dom/client'); //eslint-disable-line

  nodeList.forEach(node =>
    createRoot(node).render(<Component {...node.dataset} />)
  );
}

export function global() {
  const $inputFields = document._$$('.form-input__field');

  new Chatbot(document);
  instantiateModule($inputFields, InputField);
}

const instantiateModule = (elements, Module) =>
  render(elements, el => new Module(el));

const modules = [
  {
    name: 'header',
    loader: () => import('./modules/header.js')
  },
  {
    name: 'alert-banner',
    loader: () => import('./components/alert-banner')
  },
  {
    name: 'section-nav',
    loader: () => import('./modules/section-nav')
  },
  {
    name: 'carousel',
    loader: () => import('./modules/carousel')
  },
  {
    name: 'logo-carousel-row',
    loader: () => import('./modules/logo-carousel-row')
  },
  {
    name: 'testimonial-carousel',
    loader: () => import('./modules/testimonial-carousel')
  },
  {
    name: 'featured-blog-listing',
    loader: () => import('./modules/featured-blog-listing')
  },
  {
    name: 'modal',
    loader: () => import('./modules/modal')
  },
  {
    name: 'masonry-gallery',
    loader: () => import('./modules/masonry-gallery')
  },
  {
    name: 'date-picker',
    loader: () => import('./modules/date-picker'),
    render: reactComponent
  },
  {
    name: 'video',
    loader: () => import('./modules/video')
  },
  {
    name: 'masthead-project-listing-carousel',
    loader: () => import('./modules/masthead-project-listing-carousel')
  },
  {
    name: 'statistic-carousel',
    loader: () => import('./modules/statistic-carousel')
  },
  {
    name: 'masthead-system-detail',
    loader: () => import('./modules/masthead-system-detail')
  },
  {
    name: 'masthead-system-listing',
    loader: () => import('./modules/masthead-system-listing')
  },
  {
    name: 'tabbed-content',
    loader: () => import('./modules/tabbed-content')
  },
  {
    name: 'tabbed-featured-content',
    loader: () => import('./modules/tabbed-featured-content')
  },
  {
    name: 'breadcrumbs',
    loader: () => import('./components/breadcrumbs')
  },
  {
    name: 'rep-list',
    loader: () => import('./modules/rep-list'),
    render: reactComponent
  },
  {
    name: 'project-list',
    loader: () => import('./modules/project-list'),
    render: reactComponent
  },
  {
    name: 'system-list',
    loader: () => import('./modules/system-list'),
    render: reactComponent
  },
  {
    name: 'video-list',
    loader: () => import('./modules/video-list'),
    render: reactComponent
  },
  {
    name: 'system-documents',
    loader: () => import('./modules/system-documents'),
    render: reactComponent
  },
  {
    name: 'document-cart',
    loader: () => import('./modules/document-cart'),
    render: reactComponent
  },
  {
    name: 'document-list-with-filter',
    loader: () => import('./modules/document-list-with-filter'),
    render: reactComponent
  },
  {
    name: 'document-list-with-buttons',
    loader: () => import('./modules/document-list-with-buttons'),
    render: reactComponent
  },
  {
    name: 'gallery-row',
    loader: () => import('./modules/gallery-row')
  }, // Coveo Headless Modules
  {
    name: 'header-search',
    loader: () => import('./modules/coveo/modules/header-search'),
    render: reactComponent
  },
  {
    name: 'global-search-listing',
    loader: () => import('./modules/coveo/modules/global-search-listing'),
    render: reactComponent
  },
  {
    name: 'system-listing',
    loader: () => import('./modules/coveo/modules/system-listing'),
    render: reactComponent
  },
  {
    name: 'document-lookup',
    loader: () => import('./modules/coveo/modules/document-lookup'),
    render: reactComponent
  },
  {
    name: 'project-listing',
    loader: () => import('./modules/coveo/modules/project-listing'),
    render: reactComponent
  },
  {
    name: 'video-listing',
    loader: () => import('./modules/coveo/modules/video-listing'),
    render: reactComponent
  },
  {
    name: 'document-listing',
    loader: () => import('./modules/coveo/modules/document-listing'),
    render: reactComponent
  },
  {
    name: 'document-tab-listing',
    loader: () => import('./modules/coveo/modules/document-tab-listing'),
    render: reactComponent
  },
  {
    name: 'territory-manager-lookup',
    loader: () => import('./modules/territory-manager-lookup'),
    render: reactComponent
  },
  {
    name: 'material-estimating-calculator',
    loader: () => import('./modules/material-estimating-calculator'),
    render: reactComponent
  },
  {
    name: 'flashing-system-calculator',
    loader: () => import('./modules/flashing-system-calculator'),
    render: reactComponent
  },
  {
    name: 'media-gallery',
    loader: () => import('./modules/media-gallery')
  },
  {
    name: 'figure',
    loader: () => import('./components/Figure')
  },
  {
    name: 'share',
    loader: () => import('./modules/share')
  },
  {
    name: 'category-selection-bar',
    loader: () => import('./modules/category-selection-bar')
  },
  {
    name: 'predictive-search',
    loader: () => import('./modules/coveo/components/predictive-search'),
    render: reactComponent
  },
  {
    name: 'project-masthead-carousel',
    loader: () => import('./modules/project-masthead-carousel')
  },
  {
    name: 'blog-category-masthead',
    loader: () => import('./modules/blog-category-masthead')
  },
  {
    name: 'blog-sticky-jumplinks',
    loader: () => import('./modules/blog-sticky-jumplinks')
  }
];

export default [...globModules, ...modules];
